import React from "react";
import styled from "styled-components";

import { UseOnClickArgs, useOnClickProps } from "../hooks/useOnClickProps";

import { HexAnchorButton, HexAnchorButtonProps } from "./HexButton";

type HexLinkProps = Pick<UseOnClickArgs, "to" | "target" | "replace">;

export const HexLinkButton = React.forwardRef<
  HTMLAnchorElement,
  HexAnchorButtonProps & HexLinkProps
>(function HexLinkButton(
  { children, onClick, replace, target, to, ...otherProps },
  ref,
) {
  const linkProps = useOnClickProps({
    replace,
    onClick,
    target,
    to,
  });
  return (
    <HexAnchorButton {...otherProps} {...linkProps} ref={ref}>
      {children}
    </HexAnchorButton>
  );
});

export const ResetAnchor = styled.a<{ $muted?: boolean }>`
  ${({ theme }) => theme.resets.a}
  text-decoration: none;
  && {
    color: ${({ $muted, theme }) =>
      $muted ? theme.fontColor.MUTED : "inherit"};
  }

  /*
  This is required to show underlines in reset anchors in toasts which set their own overrides
  3 &s for specificity
  */
  &&&:hover {
    text-decoration: underline;
  }
`;

export const HexCleanLink = React.forwardRef<
  HTMLAnchorElement,
  HexLinkProps & {
    children?: React.ReactNode;
    className?: string;
    muted?: boolean;
    onContextMenu?: React.MouseEventHandler<HTMLAnchorElement>;
    onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLElement>;
  }
>(function HexCleanLink(
  { children, className, muted, onClick, onContextMenu, replace, target, to },
  ref,
) {
  const linkProps = useOnClickProps({
    replace,
    target,
    to,
    onClick,
  });
  return (
    <ResetAnchor
      className={className}
      {...linkProps}
      ref={ref}
      $muted={muted}
      onContextMenu={onContextMenu}
    >
      {children}
    </ResetAnchor>
  );
});
